












































































import Vue from 'vue';
import GVisitorCard from '@/components/GVisitorCard.vue';
// import favorite from '@/modules/analysis/favorite';
import {
  Entry,
  Buyer,
  buyer as buyerM,
  BuyerCompany,
  buyerCompany as buyerCompanyM,
  Exhibition,
  exhibition as exhibitionM,
  entry as entryM,
  OfflineDay,
  Offline,
  calender,
  contact,
  brand,
  createNewContact,
} from 'mostra';
// import contact, { createNewContact, Contact, SnapShot } from '@/modules/contact/contact'

import {
  genDownloadImageUrlByImage,
  sizes,
  // Image,
} from '@/modules/image';

type EntryInfo = {
  entry: Entry;
  buyer: Buyer;
  buyerCompany: BuyerCompany;
  businessCardImage: string | null;
  icon: string | null;
};

export type DataType = {
  initialLoading: boolean;
  loadingMore: boolean;
  hasMore: boolean;
  currentPage: number;
  pageSize: number;
  exhibition: Exhibition | null;
  day: OfflineDay | null;
  offline: Offline | null;
  entries: EntryInfo[];
  exhibitionId: string | null;
  offlineId: string | null;
  dayId: string | null;
  brands: any[];
  brandId: string | null;
  allEntries: Entry[]; // 全エントリーを保持
}

export default Vue.extend({
  name: 'exhibitor-vis-exhibition',
  components: {
    GVisitorCard,
  },
  data(): DataType {
    return {
      initialLoading: true,
      loadingMore: false,
      hasMore: true,
      currentPage: 0,
      pageSize: 10,
      entries: [],
      exhibition: null,
      day: null,
      offline: null,
      exhibitionId: null,
      offlineId: null,
      dayId: null,
      brands: [],
      brandId: null,
      allEntries: [],
    };
  },
  methods: {
    formatDateDot(dt: any): string {
      return calender.formatDateDot(dt);
    },

    // スクロール検知
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // スクロールが下部に近づいたら次のページを読み込み
      if (scrollTop + windowHeight >= documentHeight - 100 && !this.loadingMore && this.hasMore) {
        this.loadMoreEntries();
      }
    },

    // 次のページを読み込み
    async loadMoreEntries() {
      if (this.loadingMore || !this.hasMore) return;

      this.loadingMore = true;
      try {
        const startIndex = this.currentPage * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        const pageEntries = this.allEntries.slice(startIndex, endIndex);

        if (pageEntries.length === 0) {
          this.hasMore = false;
          return;
        }

        // 1てユーザー体験を向上
        for (const en of pageEntries) {
          const entryInfo = await this.processEntry(en);
          if (entryInfo) {
            this.entries.push(entryInfo);
          }
        }

        this.currentPage++;

        // 次のページがないかチェック
        if (endIndex >= this.allEntries.length) {
          this.hasMore = false;
        }
      } catch (error: any) {
        console.error('Failed to load more entries:', error);
        this.$error('追加データの読み込みに失敗しました');
      } finally {
        this.loadingMore = false;
      }
    },

    // エントリーを処理
    async processEntry(en: Entry): Promise<EntryInfo | null> {
      if (!(en.data.isReservation || en.data.isEntry || en.data.exitDate)) {
        return null;
      }

      if (!en.data.buyer.uid || !en.data.exhibition.exhibitionId) {
        console.warn('buyer id is not found for entry:', en.id);
        return null;
      }

      try {
        // キャッシュからbuyerを取得
        let buyer: Buyer | null = null;
        if (en.data.buyer.uid) {
          buyer = await buyerM.load(en.data.buyer.uid);
        }

        if (!buyer || !buyer.data.cid) {
          console.warn('buyer is not found for entry:', en.id);
          return null;
        }

        // キャッシュからcompanyを取得
        let buyerCompany: BuyerCompany | null = null;
        if (buyer.data.cid) {
          buyerCompany = await buyerCompanyM.load(buyer.data.cid);
        }

        if (!buyerCompany) {
          console.warn('buyerCompany is not found for entry:', en.id);
          return null;
        }

        // 画像URLをキャッシュから取得または生成
        let businessCardImage = null;
        if (buyer.data.businessCard?.image) {
          businessCardImage = await genDownloadImageUrlByImage(sizes.x1024, buyer.data.businessCard.image);
        }

        let icon = null;
        if (buyer.data.profileImage) {
          icon = await genDownloadImageUrlByImage(sizes.x512, buyer.data.profileImage);
        }

        return {
          entry: en,
          buyer,
          buyerCompany,
          businessCardImage,
          icon,
        };
      } catch (error: any) {
        console.error('Failed to process entry:', en.id, error);
        return null;
      }
    },

    async onContact(entry: EntryInfo) {
      try {
        this.$loading(true);
        const brandId = this.brandId;
        const uid = this.$auth.uid;
        const exhibitorCId = this.$auth.cid;
        const buyerCId = entry.buyerCompany.id;
        const isSignedInExhibitor = this.$auth.isExhibitor;

        if (!exhibitorCId) {
          throw new Error('exhibitorCId is not found');
        }
        if (!buyerCId) {
          throw new Error('buyerCId is not found');
        }

        if (!brandId) {
          this.$error('ブランドを選択してください');
          return;
        }
        const contactId = await contact.existsContact(brandId, buyerCId, exhibitorCId);

        if (contactId) {
          await this.$success('お問い合わせ済みです');
          this.$router.push({
            name: 'exhibitor-contact-chat',
            params: {
              id: contactId,
            },
          });
          return;
        }

        const contactFrom: 'exhibitor' | 'buyer' = isSignedInExhibitor ? 'exhibitor' : 'buyer';
        const newContact = await createNewContact(
          exhibitorCId,
          buyerCId,
          brandId,
          contactFrom,
        );

        const res = await contact.save(uid, newContact);
        if (!res.id) { throw new Error('Can not send contact'); }
        await this.$success('お問い合わせを完了しました');
        this.$router.push({
          name: 'exhibitor-contact-chat',
          params: {
            id: res.id,
          },
        });
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
  },
  async mounted() {
    this.initialLoading = true;
    try {
      const {
        exhibitionId,
        offlineId,
        dayId,
      } = this.$route.params;

      // http://localhost:4023/web/exhibitor/vis/exh/UsnFt9MWtqJXhTB3kWhu/o/522d21c2-7f46-45c8-835f-469aa9395954-2/d/58042efd-e5ee-47ef-a75c-16148f5ea063
      console.log('exhibitionId', exhibitionId);
      console.log('offlineId', offlineId);
      console.log('dayId', dayId);

      if (!exhibitionId) {
        throw new Error('exhibitionId is not found');
      }
      if (!offlineId) {
        throw new Error('offlineId is not found');
      }
      if (!dayId) {
        throw new Error('dayId is not found');
      }

      this.exhibitionId = exhibitionId;
      this.offlineId = offlineId;
      this.dayId = dayId;

      const brands = await brand.loadsByOwner(this.$auth.cid);
      if (!brands.length) {
        throw new Error('brand is not found:');
      }
      // this.brandId = brands[0].id;
      this.brands = brands.map((b: any) => ({
        value: b.id,
        text: b.data.base.name,
      }));

      const exhibition = await exhibitionM.load(exhibitionId);
      if (!exhibition) {
        throw new Error('exhibition is not found');
      }

      const offline = exhibition.data.offlines.find((o: any) => o.id === offlineId);

      if (!offline) {
        throw new Error('offline is not found');
      }

      const day = offline.days.find((d: any) => d.id === dayId);

      if (!day) {
        throw new Error('day is not found');
      }

      const ens = await entryM.loadsByParams(
        exhibitionId,
        offlineId,
        dayId,
      );

      // フィルタリングされたエントリーを取得
      const validEntries = ens.filter((en: any) => en.data.isReservation || en.data.isEntry || en.data.exitDate);

      // 入場日時の新しい順でソート
      const sortedEntries = validEntries.sort((a: any, b: any) => {
        // entryDateを優先、なければexitDate、なければupdatedDtを使用
        const dateA = a.data.entryDate || a.data.exitDate || a.data.updatedDt;
        const dateB = b.data.entryDate || b.data.exitDate || b.data.updatedDt;

        if (!dateA && !dateB) return 0;
        if (!dateA) return 1; // dateAがない場合は後ろに
        if (!dateB) return -1; // dateBがない場合は前に

        // 新しい順（降順）
        return dateB - dateA;
      });

      this.exhibition = exhibition;
      this.day = day;
      this.offline = offline;
      this.allEntries = sortedEntries; // ソート済みエントリーを保持
      this.currentPage = 0; // ページネーションの初期化
      this.loadMoreEntries(); // 初回ロード
      console.log(this.entries);

      // スクロールイベントリスナーを追加
      window.addEventListener('scroll', this.handleScroll);
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.initialLoading = false;
    }
  },
  beforeDestroy() {
    // スクロールイベントリスナーを削除
    window.removeEventListener('scroll', this.handleScroll);
  },
});
